export default __webpack_public_path__ + "static/media/no-group-photo.8a690504.svg";